import React, { useState } from 'react';
import { Check, X } from 'lucide-react';

interface ModerationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (action: 'approve' | 'reject', feedback?: string) => void;
  action: 'approve' | 'reject';
  isBatch?: boolean;
  selectedCount?: number;
}

export default function ModerationModal({
  isOpen,
  onClose,
  onConfirm,
  action,
  isBatch = false,
  selectedCount = 0
}: ModerationModalProps) {
  const [feedback, setFeedback] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (action === 'reject' && !feedback.trim()) {
      alert('Por favor, forneça um feedback para a rejeição.');
      return;
    }
    onConfirm(action, feedback);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">
            {action === 'approve' ? 'Aprovar' : 'Rejeitar'} {isBatch ? `${selectedCount} Reviews` : 'Review'}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {action === 'reject' && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Feedback para o cliente
            </label>
            <textarea
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={4}
              placeholder="Explique o motivo da rejeição..."
            />
          </div>
        )}

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            className={`px-4 py-2 text-white rounded-md ${
              action === 'approve'
                ? 'bg-green-500 hover:bg-green-600'
                : 'bg-red-500 hover:bg-red-600'
            }`}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
}
